import React, { FC } from 'react'
import { BackButton, ButtonOutline, Tooltip } from 'front-end/src/components'
import {
  Topbar,
  TopbarLeft,
  TopbarRight,
  TopbarTitle
} from 'front-end/src/components/common/topbar/Topbar'
import { Trans } from '@lingui/macro'
import { AdminOnlyAllowed } from 'front-end/src/components/common/AdminOnlyAllowed'
import { Link } from 'react-router-dom'
import { linkBuilder } from 'shared/linkBuilder'
import IconPencil from 'front-end/src/components/common/icon/IconPencil'

type EventTopbarProps = {
  title: string
  eventId: number
  isSeries?: boolean
}

export const EventTopbar: FC<EventTopbarProps> = ({
  title,
  eventId,
  isSeries = false
}) => {
  return (
    <Topbar>
      <TopbarLeft>
        <Tooltip tabIndex={-1} text={<Trans>Back</Trans>}>
          <BackButton ml="4px" mr="8px" defaultPath={`/events`} />
        </Tooltip>

        <TopbarTitle>{title || ''}</TopbarTitle>
      </TopbarLeft>

      <TopbarRight>
        <AdminOnlyAllowed allowManagerAccess>
          <ButtonOutline
            as={Link}
            to={linkBuilder.manageEvent(eventId, isSeries)}
            leftIcon={<IconPencil />}
          >
            {isSeries ? <Trans>Edit event series</Trans> : <Trans>Edit</Trans>}
          </ButtonOutline>
        </AdminOnlyAllowed>
      </TopbarRight>
    </Topbar>
  )
}

export default EventTopbar
